import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AccountService } from '../../../services/account.service';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { OauthActionTypes, OauthActions } from '../actions/oauth.actions';
import { catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { OauthLoginParam, OauthLoginResult, OauthExchangeParam, AccountOauthSWParam } from '../oauth.model';
import { OAuthPlatformType, OAuthPurposeType, OAuthLoginMessage, AuthOtpType, AuthOtpDeviceType } from 'src/app/shareModel';
import { UtilsService } from '../../../services/utils.service';
import * as actions from '../../../store/actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class OauthEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private accountService = inject(AccountService);
  private utils = inject(UtilsService);
  private injector = inject(Injector);


  constructor() {}

  ExchangeGoogleUserInfo$ = createEffect(() => this.actions$.pipe(
    ofType(OauthActionTypes.GetExchangeGoogleUserInfo),
    switchMap((action: any) => {
      return this.accountService.ExchangeGoogleUserInfo(action.payload.Access_token).pipe(
        map((res: any) => {
          if (res) {
            if (action.payload.Purpose === OAuthPurposeType.LoginOauth || action.payload.Purpose === OAuthPurposeType.LoginOauthBySW) {
              const param: OauthLoginParam = {
                Platform: OAuthPlatformType.Google,
                PId: res.id,
                Email: res.email,
                WithDevice: true,
                Code: '',
                FirstName: res.given_name,
                LastName: res.family_name,
                Purpose: OAuthPurposeType.LoginOauth
              };
              if (action.payload.Purpose === OAuthPurposeType.LoginOauthBySW) {
                param.app = action.payload.app;
                param.time = action.payload.time;
                param.uid = action.payload.uid;
                param.Purpose = OAuthPurposeType.LoginOauthBySW;
              }
              return new featureActions.GetOauthLogin(param);
            }
            if (action.payload.Purpose === OAuthPurposeType.AddOauth) {
              const param: OauthLoginParam = {
                Platform: OAuthPlatformType.Google,
                PId: res.id,
                Email: res.email,
                WithDevice: true,
                Code: '',
                Purpose: OAuthPurposeType.AddAccountFromWeb
              };
              return new featureActions.AddAccountOauth(param);
            }
          } else {
            const updateRes: UpdateInfoModel = {
              result: false,
              msg: '',
              errmsg: this.injector.get(TranslateService).instant('OAuth Login Failed'),
              type: updateInfoType.GoogleOAuthLogin
            };
            return new featureActions.UpdateInfoFailAction(updateRes);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.GoogleOAuthLogin
          };
          return of(new featureActions.UpdateInfoFailAction(updateRes));
        })
      );
    })
  ));
  GetFacebookAccessToken$ = createEffect(() => this.actions$.pipe(
    ofType(OauthActionTypes.GetFacebookAccessToken),
    switchMap((action: any) => {
      return this.accountService.GetFacebookAccessToken(action.payload.Code, action.payload.Redirect_Url).pipe(
        map((res: any) => {
          if (res.access_token) {
            const param: OauthExchangeParam = {
              Code: action.payload.Code,
              Purpose: action.payload.Purpose,
              Access_token: res.access_token,
              app: action.payload.app,
              time: action.payload.time,
              uid: action.payload.uid
            };
            return new featureActions.GetExchangeFacebookUserInfo(param);
          } else {
            const updateRes: UpdateInfoModel = {
              result: false,
              msg: '',
              errmsg: this.injector.get(TranslateService).instant('OAuth Login Failed'),
              type: updateInfoType.FacebookOAuthLogin
            };
            return new featureActions.UpdateInfoFailAction(updateRes);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.FacebookOAuthLogin
          };
          return of(new featureActions.UpdateInfoFailAction(updateRes));
        })
      );
    })
  ));
  GetExchangeFacebookUserInfo$ = createEffect(() => this.actions$.pipe(
    ofType(OauthActionTypes.GetExchangeFacebookUserInfo),
    switchMap((action: any) => {
      return this.accountService.ExchangeFacebookUserInfo(action.payload.Access_token).pipe(
        map((res: any) => {
          if (res && res.email) {
            const param: OauthLoginParam = {
              Platform: OAuthPlatformType.Facebook,
              PId: res.id,
              Email: res.email,
              WithDevice: true,
              Code: '',
              Purpose: 0
            };
            if (action.payload.Purpose === OAuthPurposeType.LoginOauth || action.payload.Purpose === OAuthPurposeType.LoginOauthBySW) {
              param.FirstName = res.first_name;
              param.LastName = res.last_name;
              param.Purpose = OAuthPurposeType.LoginOauth;
              if (action.payload.Purpose === OAuthPurposeType.LoginOauthBySW) {
                param.app = action.payload.app;
                param.time = action.payload.time;
                param.uid = action.payload.uid;
                param.Purpose = OAuthPurposeType.LoginOauthBySW;
              }
              return new featureActions.GetOauthLogin(param);
            }
            if (action.payload.Purpose === OAuthPurposeType.AddOauth) {
              param.Purpose = OAuthPurposeType.AddAccountFromWeb;
              return new featureActions.AddAccountOauth(param);
            }
          } else {
            const updateRes: UpdateInfoModel = {
              result: false,
              msg: '',
              errmsg: this.injector.get(TranslateService).instant('OAuth Login Failed'),
              type: updateInfoType.FacebookOAuthLogin
            };
            return new featureActions.UpdateInfoFailAction(updateRes);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.FacebookOAuthLogin
          };
          return of(new featureActions.UpdateInfoFailAction(updateRes));
        })
      );
    })
  ));
  GetOauthLogin$ = createEffect(() => this.actions$.pipe(
    ofType(OauthActionTypes.GetOauthLogin),
    switchMap((action: any) => {
      return this.accountService.OAuthLogin(action.payload).pipe(
        switchMap((res: any) => {
            if (res.Flag) {
            const accountOauthSWParam: AccountOauthSWParam = {
              UId: action.payload.uid,
              Platform: action.payload.Platform,
              PId: action.payload.PId,
              SW: action.payload.app,
              ExpiredTimeStamp: action.payload.time,
              Email: action.payload.Email
            };
            const token = JSON.parse(this.utils.getToken());
            const isEnterpriseSso = action.payload.Platform === OAuthPlatformType.SSO;
            // EnableOtp 雙因驗證
            if (res.EnableOtp) {
              const param = {
                otp: res.OtpKey,
                DeviceType: AuthOtpDeviceType.Web,
                AuthType: AuthOtpType.Login,
              };
              this.utils.writeToken({...token,
                userToken: res.token
              });
              return [new featureActions.AddAuthOtp(param),
                      new featureActions.GetAccountOauthSWParam(accountOauthSWParam)];
            } else {
              if (action.payload.Purpose === OAuthPurposeType.LoginOauthBySW) {
                return [new featureActions.AddAccountOauthSW(accountOauthSWParam)];
              } else {
                // oauth login 帳號成功即登入
                this.utils.writeToken({
                  value: res.OtpKey,
                  timestamp: new Date().getTime(),
                  username: res.Account,
                  acode: Number(res.acode),
                  RegionId: res.RegionId,
                  Package: res.Package,
                  ssocookie: ( isEnterpriseSso && token && token.ssocookie) ? token.ssocookie : null,
                  // ssocookie : 用在SSO登入頁cookie
                  ssouser: ( isEnterpriseSso ) ? action.payload.Email : null,
                  // ssouser : 用在SSO登入頁輸入之account與azure return回來之帳號比對是否一致
                  userToken: res.token,
                  IsMsp: res.IsMsp,
                });
                return [new featureActions.OauthLogin(res),
                          new actions.LoginSuccessAction({
                            username: res.Account,
                            OtpKey: res.OtpKey,
                            acode: Number(res.acode),
                            RegionId: res.RegionId,
                            Package: res.Package,
                            IsMsp: res.IsMsp
                          })];
              }
            }
          } else {
            const errorResult = {
              ...res,
              Email: action.payload.Email,
              ...(Number(res.Message) === OAuthLoginMessage.AddAccountAvailable && {
                Platform: action.payload.Platform,
                PId: action.payload.PId,
                FirstName: action.payload.FirstName,
                LastName: action.payload.LastName,
                app: action.payload.app,
                time: action.payload.time,
                uid: action.payload.uid
              })
            };
            return [new featureActions.OauthLoginFail(errorResult)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          const result: OauthLoginResult = {
            Flag: false,
            Message: error
          };
          return of(new featureActions.OauthLoginFail(result));
        })
      );
    })
  ));
  AddAccountByOauth$ = createEffect(() => this.actions$.pipe(
    ofType(OauthActionTypes.AddAccountByOauth),
    switchMap((action: any) => {
      return this.accountService.AddAccountByOAuth(action.payload).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            // Add 帳號成功即登入
            if (action.payload.Purpose === OAuthPurposeType.AddAccountFromWeb) {
              const result = { ...res, username: action.payload.Email };
              const token = JSON.parse(this.utils.getToken());
              const isEnterpriseSso = action.payload.Platform === OAuthPlatformType.SSO;
              this.utils.writeToken({...token,
                value: result.OtpKey,
                timestamp: new Date().getTime(),
                username: result.Account,
                acode: Number(result.acode),
                RegionId: result.RegionId,
                Package: result.Package,
                ssocookie: ( isEnterpriseSso ) ? action.payload.Email : null,
                userToken: result.token
              });
              return [new featureActions.OauthLogin(result),
                        new actions.LoginSuccessAction({
                          username: result.username,
                          OtpKey: result.OtpKey,
                          acode: Number(result.acode),
                          RegionId: result.RegionId,
                          Package: result.Package,
                          IsMsp: result.IsMsp
                        })];

            }
            if (action.payload.Purpose === OAuthPurposeType.AddAccountFromSW) {
              const param: AccountOauthSWParam = {
                UId: action.payload.uid,
                Platform: action.payload.Platform,
                PId: action.payload.PId,
                SW: action.payload.app,
                ExpiredTimeStamp: action.payload.time,
                Email: action.payload.Email
              };
              return [new featureActions.AddAccountOauthSW(param)];
            }
          } else {
            return [new featureActions.OauthLoginFail(res)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          const result: OauthLoginResult = {
            Flag: false,
            Message: error
          };
          return of(new featureActions.OauthLoginFail(result));
        })
      );
    })
  ));
  AddAccountOauth$ = createEffect(() => this.actions$.pipe(
    ofType(OauthActionTypes.AddAccountOauth),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp: user.otp,
        Platform : action.payload.Platform,
        PId: action.payload.PId,
        Email: action.payload.Email
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        errmsg: '',
        type: updateInfoType.AddOAuth
      };
      return this.accountService.AddAccountOAuth(param).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            const msg = action.payload.Email !== user.currentUser
              ? {
                  msg: OAuthLoginMessage.ChooseEmail,
                  Platform : action.payload.Platform,
                  AccountEmail: user.currentUser,
                  PlatformEmail: action.payload.Email
                }
              : updateRes.msg;
            return [new featureActions.GetOauths(),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg })];
          } else {
            return [new featureActions.LoadOauthsFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.Message })];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          return [new featureActions.LoadOauthsFail(),
                  new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Error' })];
        })
      );
    })
  ));
  GetOauth$ = createEffect(() => this.actions$.pipe(
    ofType(OauthActionTypes.GetOauths),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const param = {
        otp: user.otp
      };
      return this.accountService.ReadAccountOAuth(param).pipe(
        map((res: any) => {
          if (res.length === undefined) { res = []; }
          return new featureActions.LoadOauths(res);
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.ReadOAuth
          };
          return [new featureActions.LoadOauthsFail(),
                  new featureActions.UpdateInfoFailAction(updateRes)];
        })
      );
    })
  ));
  DeleteAccountOauth$ = createEffect(() => this.actions$.pipe(
    ofType(OauthActionTypes.DeleteAccountOauth),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp: user.otp,
        Id: action.payload.Id
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        errmsg: '',
        type: updateInfoType.DeleteOAuth
      };
      return this.accountService.DeleteAccountOAuth(param).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.DeleteAccountOauthSuccess({id : action.payload.Id}),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: action.payload.Email, result: true })];
          } else {
            return [new featureActions.LoadOauthsFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.Message })];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          return [new featureActions.LoadOauthsFail(),
                  new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Error' })];
        })
      );
    })
  ));
  UpdateAccountEmail$ = createEffect(() => this.actions$.pipe(
    ofType(OauthActionTypes.UpdateAccountEmail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp: user.otp,
        Email: action.payload.Email
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        errmsg: '',
        type: action.payload.UpdateType
      };
      return this.accountService.UpdateAccountEmail(param).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.GetOauths(),
                    // new featureActions.GetClientAccount(),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: action.payload.Email, result: true })];
          } else {
            return [new featureActions.LoadOauthsFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.Message })];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          return [new featureActions.LoadOauthsFail(),
                  new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Error' })];
        })
      );
    })
  ));
  AddAccountOauthSW$ = createEffect(() => this.actions$.pipe(
    ofType(OauthActionTypes.AddAccountOauthSW),
    switchMap((action: any) => {
      const param = {
        UId: action.payload.UId,
        SW: action.payload.SW,
        ExpiredTimeStamp: new Date().getTime(),
        Platform : action.payload.Platform,
        PlatformId: action.payload.PId,
        Email: action.payload.Email
      };
      return this.accountService.AddAccountOAuthSW(param).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.OauthLogin(res)];
          } else {
            return [new featureActions.OauthLoginFail(res)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          const result: OauthLoginResult = {
            Flag: false,
            Message: error
          };
          return [new featureActions.OauthLoginFail(result)];
        })
      );
    })
  ));
}
